import { styled, Typography } from '@mui/material'

export const ShortedTypography = styled(Typography)({
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    // whiteSpace: 'nowrap',
})
